import NoData from "@Components/NoData/NoData";
import TopupCard from "../TopupCard/TopupCard";
import { useTranslation } from "react-i18next";
import { useGetTopupWithDetailsQuery } from "src/store/apis/Topup";
import { useTopupListing } from "../../context/TopupListingContext";

const TopupListLoading = () => {
  return (
    <div className="grid w-full grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
      {Array.from({ length: 10 }).map((_, i) => {
        return <TopupCard loading={true} key={`discounts-${i}`} code={"###"} />;
      })}
    </div>
  );
};

export default function TopupList() {
  const { filters } = useTopupListing();
  const { i18n } = useTranslation();
  const { isFetching, data, error } = useGetTopupWithDetailsQuery({
    ...filters,
    Page: 1,
    PageSize: 100000,
    lang: i18n.language,
  });
  if (isFetching) return <TopupListLoading />;
  if (error || !data?.length)
    return (
      <div className="flex min-h-[50vh] w-full items-center justify-center">
        <NoData />
      </div>
    );

  return (
    <div className="grid w-full grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
      {data?.map((item) => {
        return (
          <TopupCard code={item.code} imageUrl={item.imageUrl ?? ""} />
        );
      })}
    </div>
  );
}
